// Import Select2 jQuery lib (added with `yarn add select2`)
import 'select2/dist/js/select2.min.js';

export default {
  init() {
    // JavaScript to be fired on the events page

    const filterSelect = $('.js-event-filter-select');

    // Init custom dropdown/select
    filterSelect.select2({
      dropdownParent: filterSelect.parent(),
      minimumResultsForSearch: 10,
    });

    // Update filter on dropdown/select change
    filterSelect.on('change', () => {
      $('.js-event-filters-form').submit();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/events.js